import './App.css';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PermanentFrame from './components/boilerplate/PermanentFrame';
import { useStytchUser, useStytch } from '@stytch/react';
import Login from './components/auth/Login';
import { checkStorageVersion } from './utilities/storageVersionCheck';
import { updateUserEmail } from './redux/app/configSlice';
import { initAuthService } from './services/authService';

function App() {
  // The useStytchUser hook will return the existing Stytch User object if one exists
  // const value = useSelector(RegionModal)
  const { user } = useStytchUser();
  const stytch = useStytch();
  const dispatch = useDispatch();

  // Check storage version and clear outdated data
  checkStorageVersion();

  // Initialize auth service with Stytch client
  useEffect(() => {
    if (stytch) {
      initAuthService(stytch);
    }
  }, [stytch]);

  // Set user email in Redux when Stytch user is available
  useEffect(() => {
    if (user?.emails?.[0]?.email) {
      dispatch(updateUserEmail(user.emails[0].email));
    }
  }, [user, dispatch]);

  return (
    <>
      {user ? <PermanentFrame /> : <Login />}
      {/* <PermanentFrame /> */}
    </>
  );
}

// testing changes;
export default App;

// Hello World
